<template>
	<div class="flex min-h-screen flex-col items-center justify-center bg-slate-100 dark:bg-slate-900">
		<div class="w-24 h-24 bg-white dark:bg-slate-800 rounded-full flex items-center justify-center shadow-sm p-6">
			<LogoLoader />
		</div>
	</div>
</template>
